import React from 'react';
import Alert from '@mui/material/Alert';

const Success = ({ message }) => <Alert severity='success'>{message}</Alert>;

export default Success;
